// extracted by mini-css-extract-plugin
export var compactFilters = "_dr-4";
export var detailImage = "_dr-1";
export var dropdownContainer = "_dr-2";
export var imageContainer = "_dr-0";
export var selectedCard = "_dr-3";